import { useState } from 'react';
import styles from './faq.module.scss';

const Faq = ({ faqs = [] }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFaq = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={styles.faqContainer}>
            {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                    <div key={index} className={styles.faqItem}>
                        <div className={styles.faqQuestion} onClick={() => toggleFaq(index)}>
                            <span>{faq.question}</span>
                            <span className={`${styles.icon} ${isOpen ? styles.iconOpen : ''}`}>
                                <span className={styles.horizontal}></span>
                                <span className={styles.vertical}></span>
                            </span>
                        </div>

                        <div className={`${styles.faqAnswerWrapper} ${isOpen ? styles.open : ''}`}>
                            <div className={styles.faqAnswer}>{faq.answer}</div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Faq;
